/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SnapshotReference } from '../models/SnapshotReference';
import { VaultSnapshotCount } from '../models/VaultSnapshotCount';
import { YearlySnapshotDistribution } from '../models/YearlySnapshotDistribution';

/**
* Summary of snapshots for a resource
*/
export class SnapshotsSummaryResponse {
  /**
  * Total number of snapshots for this resource
  */
  'totalCount': number;
  /**
  * Number of native snapshots (stored in cloud provider, not in Eon vault)
  */
  'nativeSnapshotCount'?: number;
  'oldestSnapshot'?: SnapshotReference;
  'latestSnapshot'?: SnapshotReference;
  /**
  * Snapshot counts grouped by vault
  */
  'snapshotsPerVault': Array<VaultSnapshotCount>;
  /**
  * For Aurora Global Database clusters, the total snapshot count across all related cluster members. Only present when the resource is part of a Global Database. 
  */
  'clusterTotalCount'?: number;
  'clusterOldestSnapshot'?: SnapshotReference;
  'clusterLatestSnapshot'?: SnapshotReference;
  /**
  * Snapshot distribution grouped by year and month, sorted by year descending (most recent first)
  */
  'years'?: Array<YearlySnapshotDistribution>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "nativeSnapshotCount",
      "baseName": "nativeSnapshotCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "oldestSnapshot",
      "baseName": "oldestSnapshot",
      "type": "SnapshotReference",
      "format": ""
    },
    {
      "name": "latestSnapshot",
      "baseName": "latestSnapshot",
      "type": "SnapshotReference",
      "format": ""
    },
    {
      "name": "snapshotsPerVault",
      "baseName": "snapshotsPerVault",
      "type": "Array<VaultSnapshotCount>",
      "format": ""
    },
    {
      "name": "clusterTotalCount",
      "baseName": "clusterTotalCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "clusterOldestSnapshot",
      "baseName": "clusterOldestSnapshot",
      "type": "SnapshotReference",
      "format": ""
    },
    {
      "name": "clusterLatestSnapshot",
      "baseName": "clusterLatestSnapshot",
      "type": "SnapshotReference",
      "format": ""
    },
    {
      "name": "years",
      "baseName": "years",
      "type": "Array<YearlySnapshotDistribution>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SnapshotsSummaryResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

